import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Box,
  Grid,
  Tooltip,
  CircularProgress,
  IconButton,
} from "@mui/material";
import ReactPlayer from "../scribe/AudioPlayer";

import CloseIcon from "@material-ui/icons/Close";
import { getDictation, getIVRCallAudio } from "apiHandler/actions";
import { useUserData } from "../customHooks/userDataContext";
import PatientNotes from "components/patient/PatientNotes";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import PersonalInfoPlayer from "components/scribe/PersonalInfoPlayer";
import TranscriptionText from "components/scribe/transcriptionText";

const MyModal = ({
  onClose,
  text,
  id,
  currentPlaying,
  setCurrentPlaying,
  npi,
  encounter_id,
  practice_id,
  updateNotes,
  categories,
  fetchedNotes,
  savedNotes,
  isIVRCall = false,
  details,
}) => {
  console.log("text>>: ", text);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [audio, setAudio] = useState(null);
  const [error, setError] = useState(false);
  const audioRef = useRef();

  const userData = useUserData();
  const token = userData?.access_token;

  useEffect(() => {
    fetchAudio(false);
  }, []);

  const fetchAudio = async (download) => {
    if (id !== currentPlaying) {
      await setCurrentPlaying(id);
      // setOpen(true);
    }
    let response = audio;
    if (error) {
      // setOpen(true);
      return;
    }
    if (!loading && !audio && id && !error) {
      if (download) setError("Download in progress...");
      else setLoading(true);
      const payload = {
        type: "Dictation",
        search_criteria: {
          practice_id: `${practice_id}`,
          npi: npi,
          dictation_id: id,
        },
      };
      if (isIVRCall) {
        response = await getIVRCallAudio(
          {
            practice_id: `${practice_id}`,
            id: id.toString(),
          },
          token
        );
      } else {
        response = await getDictation(payload, token);
      }
      if (response === "ERROR" || !response) {
        setError("Failed to get the audio");
        setLoading(false);
        return;
      } else {
        setAudio(response);
        setError("");
      }
    }
    setLoading(false);
    if (setCurrentPlaying) {
      await setCurrentPlaying(id);
    }
    // setOpen(true);
  };

  const handleSeek = (seconds) => {
    if (audioRef.current) {
      audioRef.current.currentTime = seconds;
      audioRef.current.play();
    }
  };

  return (
    <>
      <Modal
        open={true}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <div>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              height: "90%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              display: "flex",
              flexDirection: "column", // Stack the content vertically
              gap: 2,
              overflowY: "auto",
            }}
          >
            <Box>
              <IconButton onClick={onClose} style={{ float: "right" }}>
                <CloseIcon />
              </IconButton>
            </Box>
            {details.audio_duration && (
              <Box display={"flex"} alignItems={"center"} gap={2}>
                <span className="duration">{details.audio_duration}</span>
                <PersonalInfoPlayer
                  // showPlayer={true}
                  id={details.id}
                  currentPlaying={currentPlaying}
                  setCurrentPlaying={setCurrentPlaying}
                  practice_id={details.practice_id}
                  npi={details.npi}
                  ext={details.file_extension}
                  audioRef={audioRef}
                />
              </Box>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    maxHeight: window.innerHeight / 3,
                    overflowY: "scroll",
                    border: "1px solid grey",
                    padding: 2,
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      // justifyContent: ''
                    }}
                  >
                    <h3>Transcribed Text</h3>
                    <span style={{ float: "right" }}>
                      <div
                        style={{
                          userSelect: "text",
                          fontSize: 16,
                          textAlign: "left",
                        }}
                      >
                        <Tooltip
                          onClose={() => setOpen(false)}
                          open={open}
                          disableFocusListener
                          disableHoverListener
                          disableTouchListener
                          title="Copied"
                        >
                          <FileCopyIcon
                            fontSize="small"
                            onClick={() => {
                              setOpen(true);
                              navigator.clipboard.writeText(text);
                            }}
                            color="secondary"
                            style={{ cursor: "pointer", marginLeft: 10 }}
                          />
                        </Tooltip>
                      </div>
                    </span>
                  </div>
                  <TranscriptionText text={text} onSeek={handleSeek} />
                </Box>
              </Grid>

              {/* Text input box */}
              <Grid item xs={12}>
                <div className="dictation-notes-modal-editor">
                  <PatientNotes
                    id={id}
                    practice_id={practice_id}
                    encounter_id={encounter_id}
                    npi={npi}
                    savedNotes={savedNotes}
                    onClose={onClose}
                    updateNotes={updateNotes}
                    categories={categories}
                    fetchedNotes={fetchedNotes}
                  />
                </div>
              </Grid>

              {/* Audio player */}
              {audio && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      paddingTop: 2,
                    }}
                  >
                    {loading ? (
                      <CircularProgress color="secondary" size={20} />
                    ) : (
                      <ReactPlayer audio={audio} />
                    )}
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </div>
      </Modal>
    </>
  );
};

export default MyModal;
